import React from 'react'
import {
  Route
} from 'react-router-dom'
import { PublicLayout } from '../layouts'

export default function PublicRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={() => <PublicLayout>{children}</PublicLayout>}
    />
  )
}